import { useEffect, useState } from 'react';
import { API_BASE_URL } from '../components/config/api';

export function useTrainingMode(storeId?: number) {
  const [enabled, setEnabled] = useState(false);
  useEffect(() => {
    let active = true;
    setEnabled(false);
    if (!storeId) return;
    fetch(`${API_BASE_URL}/api/fiscal/stores/${storeId}/cashier-document-types`, {
      headers: { Authorization: `Bearer ${localStorage.getItem('xentrix_token')}` }
    }).then(async response => {
      if (!response.ok) return;
      const data = await response.json();
      if (active) setEnabled(data.trainingModeEnabled === true);
    }).catch(() => { /* Leave the gesture disabled if settings cannot load. */ });
    return () => { active = false; };
  }, [storeId]);
  return enabled;
}
